import { render, staticRenderFns } from "./HorizontalButtonsGroup.vue?vue&type=template&id=437b91c1&scoped=true&"
import script from "./HorizontalButtonsGroup.vue?vue&type=script&lang=js&"
export * from "./HorizontalButtonsGroup.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalButtonsGroup.vue?vue&type=style&index=0&id=437b91c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b91c1",
  null
  
)

export default component.exports